import { TrendingUp, TrendingDown, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { cn } from '../../lib/utils';

export default function MetricCard({ title, value, trend, status, icon: Icon, loading }) {
  if (loading) {
    return (
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
          <div className="h-8 w-8 bg-gray-200 rounded animate-pulse" />
        </CardHeader>
        <CardContent>
          <div className="h-8 w-32 bg-gray-200 rounded animate-pulse mb-2" />
          <div className="h-3 w-20 bg-gray-200 rounded animate-pulse" />
        </CardContent>
      </Card>
    );
  }

  const statusColors = {
    success: 'bg-green-500',
    warning: 'bg-orange-500',
    danger: 'bg-red-500',
    default: 'bg-blue-500'
  };

  const trendColors = {
    up: 'text-green-600',
    down: 'text-red-600',
    neutral: 'text-gray-600'
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">
          {title}
        </CardTitle>
        {Icon && (
          <div className={cn('p-2 rounded-lg text-white', statusColors[status] || statusColors.default)}>
            <Icon size={20} />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold text-gray-900">{value}</div>
        {trend && (
          <div className="flex items-center gap-1 mt-1">
            {trend.direction === 'up' ? (
              <TrendingUp size={16} className={trendColors.up} />
            ) : trend.direction === 'down' ? (
              <TrendingDown size={16} className={trendColors.down} />
            ) : null}
            <span className={cn('text-xs font-medium', trendColors[trend.direction] || trendColors.neutral)}>
              {trend.value > 0 && '+'}{trend.value}%
            </span>
            {trend.label && (
              <span className="text-xs text-gray-500">{trend.label}</span>
            )}
          </div>
        )}
        {status === 'warning' && (
          <div className="flex items-center gap-1 mt-2 text-orange-600">
            <AlertTriangle size={14} />
            <span className="text-xs font-medium">High Risk</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
